import React, { Fragment } from "react";
import { Typography } from "@mui/material";
import { Outlet } from "react-router-dom";

function YouthProgram() {
    return <><Outlet /></>;
}
export default YouthProgram;